import Auth from '@services/cognito';
import useStores from '@stores/useStores';
import { useHistory } from 'react-router-dom';
import { LoginMfaState, SessionData, TrackUserLogin } from '@stores/user';
import { memoryStore } from '@lib/memoryStore';
import { letUserKnowWeSupportMfa } from './util';

type LoginResponse = Awaited<ReturnType<typeof Auth.login>>;

export const useLogin = () => {
  const { userStore } = useStores();
  const history = useHistory();

  const onSuccess = async (
    response: LoginResponse,
    providedEmail: string,
    password: string,
    userLoginMetadata: TrackUserLogin = {},
  ) => {
    const { status, email = providedEmail } = response;

    if (status === LoginMfaState.ForcedSetup) {
      memoryStore.setItem('password', password);
      userStore.setUserSessionForMFA(email, { ...response, state: LoginMfaState.ForcedSetup });
      await userStore.trackUserLogin(userLoginMetadata);
      history.push('/addmfa');
      return;
    }

    const { accessToken, idToken, refreshToken } = response;
    await userStore.loginUser({ accessToken, idToken, refreshToken });
    await userStore.trackUserLogin(userLoginMetadata);
    letUserKnowWeSupportMfa(userStore, history);
  };

  return async (email: string, password: string, userLoginMetadata?: TrackUserLogin) => {
    const loginResponse = await Auth.login(email, password);
    await onSuccess(loginResponse, email, password, userLoginMetadata);
  };
};

export const useSendOtp = () => {
  const {
    userStore: { mfaStatus },
  } = useStores();
  const hasEnabledMfa = mfaStatus === 'SMS';

  return async (sessionData: SessionData | undefined, newNumber: string) => {
    if (hasEnabledMfa) {
      await Auth.sendOtpMfaEnabled(sessionData, newNumber);
    } else {
      await Auth.sendOtpMfaDisabled(sessionData, newNumber);
    }
  };
};
